export const nf = (n) => (n == null ? "—" : new Intl.NumberFormat("ru-RU").format(n));

/** seconds -> «2 ч 30 мин», «45 мин», «30 сек», «1 д 4 ч» */
export function fmtDuration(sec) {
  if (sec == null || !isFinite(sec)) return "—";
  const s = Math.round(sec);
  if (s < 60) return `${s} сек`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m} мин`;
  const h = Math.floor(m / 60);
  const mm = m % 60;
  if (h < 24) return mm ? `${h} ч ${mm} мин` : `${h} ч`;
  const d = Math.floor(h / 24);
  const hh = h % 24;
  return hh ? `${d} д ${hh} ч` : `${d} д`;
}

export const fmtPct = (v) =>
  v == null ? "—" : `${new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 1 }).format(v)}%`;

export const fmtNum1 = (v) =>
  v == null ? "—" : new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 1 }).format(v);

export const fmtDay = (iso) => {
  const d = new Date(`${iso}T00:00:00`);
  return isNaN(d) ? iso : d.toLocaleDateString("ru-RU", { day: "numeric", month: "short" });
};
